import React, { useState, useEffect } from 'react';
import './Homepage.css';
import profilePic from './assets/headshot.png';
import CatPic from './PixelCat3D';
import Publications from './PublicationsList';
import Projects from './Projects';
import EmailButton from './EmailButton';

const RetroControlPanel = () => {
  const [time, setTime] = useState(new Date());
  const [scanLine, setScanLine] = useState(0);
  const [glitchText, setGlitchText] = useState('~ they / them ~');
  const [floatingLeaves, setFloatingLeaves] = useState([]);
  const [butterflies, setButterflies] = useState([]);

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const scanner = setInterval(() => {
      setScanLine(prev => (prev + 1) % 100);
    }, 50);
    return () => clearInterval(scanner);
  }, []);

  useEffect(() => {
    const glitchOptions = [
      '~ they / them ~',
    ];
    const glitcher = setInterval(() => {
      if (Math.random() > 0.8) {
        setGlitchText(glitchOptions[Math.floor(Math.random() * glitchOptions.length)]);
      }
    }, 3000);
    return () => clearInterval(glitcher);
  }, []);

  useEffect(() => {
    // Create floating leaves
    const leaves = Array.from({ length: 12 }, (_, i) => ({
      id: i,
      startX: Math.random() * 100,
      startY: 20 + Math.random() * 60,
      delay: Math.random() * 2,
      duration: 12 + Math.random() * 8,
      size: 8 + Math.random() * 8
    }));
    setFloatingLeaves(leaves);

    // Create butterflies
    const butterfliesData = Array.from({ length: 3 }, (_, i) => ({
      id: i,
      startX: Math.random() * 100,
      startY: Math.random() * 60,
      delay: Math.random() * 5,
      duration: 15 + Math.random() * 10
    }));
    setButterflies(butterfliesData);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
  };

  return (
    <>
      <div className="control-panel-wrapper">
        {/* Floating leaves */}
        {floatingLeaves.map(leaf => (
          <div
            key={leaf.id}
            className="floating-leaf"
            style={{
              left: `${leaf.startX}%`,
              top: `${leaf.startY}%`,
              animationDelay: `${leaf.delay}s`,
              animationDuration: `${leaf.duration}s`,
              width: `${leaf.size}px`,
              height: `${leaf.size}px`
            }}
          ></div>
        ))}

        {/* Butterflies */}
        {butterflies.map(butterfly => (
          <div
            key={butterfly.id}
            className="butterfly"
            style={{
              left: `${butterfly.startX}%`,
              top: `${butterfly.startY}%`,
              animationDelay: `${butterfly.delay}s`,
              animationDuration: `${butterfly.duration}s`
            }}
          >
            <div className="wing left"></div>
            <div className="wing right"></div>
          </div>
        ))}

        {/* Fireflies */}
        <div className="firefly solo" style={{top: '25%', left: '15%', animationDelay: '2s'}}></div>
        <div className="firefly solo" style={{top: '70%', right: '20%', animationDelay: '5s'}}></div>
        <div className="firefly solo" style={{top: '45%', left: '60%', animationDelay: '7s'}}></div>

        <div className="control-panel">
          {/* Left Column - Info Section */}
          <div className="panel-section info-section">
            <div className="mini-screen">
              <div className="screen-header">✿ CURRENT UPDATES ✿</div>
              <div className="screen-body">
                <div className="pixel-text">Working on the website</div>
                <div className="indicator-bar">
                  <div className="bar-fill" style={{width: '40%'}}></div>
                </div>
                <div className="pixel-text">Working on a recipe book</div>
                <div className="indicator-bar">
                  <div className="bar-fill" style={{width: '20%'}}></div>
                </div>
              </div>
            </div>

            <div className="text-panel">
              <div className="label-text">✿ ABOUT ✿</div>
              <div className="info-text">
              <p>I'm a Master's student at NYU studying computer science with a concentration in systems and security.</p>
              <p>Currently, I'm the course assistant for Prof. Nir Bitansky's undergraduate algorithms course. Last semester, I TA'ed the course under Prof. Rachit Garg.
                I have also had the pleasure of teaching computer science to high schoolers for the past four summers.
              </p>
              <br/>
              <p>Outside of my studies and research, you'll find me playing some RPGs, hanging out with my cat Smaug (pictured below), or cooking a fun meal.
              I've also developped a passion for cosplay, and have recently enjoyed making chainmail.</p>
              <br/>
              Languages: English, French, Italian
              </div>
            </div>
          </div>

          {/* Right Column - Profile Display */}
          <div className="panel-section main-display">
            <div className="screen-bezel">
              <div className="crt-screen">
                <div className="scan-line" style={{ top: `${scanLine}%` }}></div>
                <div className="screen-content">
                  <div className="pixel-avatar">
                    <img src={profilePic} alt="Profile" className='avatar-image'/>
                  </div>
                  <div className="status-text">{glitchText}</div>
                </div>
                <div className="screen-flicker"></div>
              </div>
            </div>

            {/* Buttons under the screen */}
            <div className="button-cluster">
              <EmailButton />
            
              <button
                className="pixel-button"
                onClick={() =>
                  window.open(
                    "https://www.linkedin.com/in/sam-de-alfaro/",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                LINKEDIN
              </button>
              <button
                className="pixel-button"
                onClick={() =>
                  window.open(
                    "https://github.com/SamdeAlfaro",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                GITHUB
              </button>
            </div>
          </div>
        </div>

        <div className="control-panel" style={{ marginTop: '20px' }}>
          {/* Left Column */}
          <div className="panel-section info-section" style={{ flex: 1 }}>
            <CatPic />
          </div>

          {/* Right Column */}
          <div className="panel-section info-section" style={{ flex: 2 }}>
            <Publications />
          </div>
        </div>

        <div className="control-panel" style={{ marginTop: '20px' }}>
        
            <Projects />

        </div>  
        
      </div>
    </>
  );
};

export default RetroControlPanel;